import {
  Directive,
  effect,
  ElementRef,
  EmbeddedViewRef,
  inject,
  input,
  TemplateRef,
  untracked,
  ViewContainerRef
} from '@angular/core'
import tippy, { followCursor, hideAll, Props } from 'tippy.js'

export type TippyProps = Props

@Directive({
  selector: '[llaTippy]',
  standalone: false
})
export class LlaTippyDirective {
  llaTippy = input<TemplateRef<any>>()
  llaTippyProps = input<Partial<TippyProps>>({})
  llaTippyContext = input<Record<string, any>>({})

  private el = inject(ElementRef)
  private vcr = inject(ViewContainerRef)

  constructor() {
    effect((onCleanup) => {
      const template = this.llaTippy()

      if (!template) return

      const props = untracked(() => this.llaTippyProps())
      const context = untracked(() => this.llaTippyContext())
      const plugins = props.followCursor ? [followCursor] : []

      let viewRef: EmbeddedViewRef<any> | null = null

      const result = tippy(this.el.nativeElement, {
        content: '',
        allowHTML: true,
        interactive: !props.followCursor,
        appendTo: document.body,
        ...props,
        plugins,
        onShow: (inst) => {
          hideAll({ exclude: inst })
          if (!viewRef) {
            const container = document.createElement('div')
            viewRef = this.vcr.createEmbeddedView(template, {
              ...context,
              hideTippy: () => inst.hide()
            })
            viewRef.detectChanges()
            for (const node of viewRef.rootNodes) {
              container.appendChild(node)
            }
            inst.setContent(container)
          }
        }
      })
      const instance = Array.isArray(result) ? result[0] : result

      onCleanup(() => {
        instance.destroy()
        if (viewRef) {
          const index = this.vcr.indexOf(viewRef)
          if (index !== -1) {
            this.vcr.remove(index)
          }
          viewRef = null
        }
      })
    })
  }
}
